<template>
    <div class="used-car-item">
        <UsedCarListItem
            v-for="(itm, idx) in data"
            :item="itm.usedcar_data"
            :key="idx">
            <div slot="bottom">
                <van-cell title="取消收藏" title-class="btn" @click="cancelFav(itm)"></van-cell>
            </div>
        </UsedCarListItem>
    </div>
</template>

<script>
import {  
    Loading, 
    List,
    Cell
} from 'vant'

import { UsedCarFavoritesApi } from '@/api/usedcar'
import UsedCarListItem from '@/view/usedcar/components/usedcarlistitem'

export default {
    name: 'UsedCarFavorites',
    components: {
        [Loading.name]: Loading,
        [List.name]: List,
        [Cell.name]: Cell,
        UsedCarListItem
    },
    data() {
        return {
            data: [],
            total: 0,
            loading: false,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            this.axios.get(UsedCarFavoritesApi, {}).then((ret) => {
                console.log('favorites')
                console.log(ret)
                that.data = ret.results
                that.total = ret.count
            })
        },
        cancelFav(itm) {
            console.log(itm)
            var that = this
            that.axios.delete(UsedCarFavoritesApi + itm.id + "/").then((ret) => {
                console.log('cancelFav')
                console.log(ret)
                that.getData()
            })
        },
        onClickLeft() {

        }
    }
}
</script>

<style lang="less">
.used-car-item {
    .btn {
        color: #2196F3;
    }
}
</style>
